import React, { useRef } from 'react'
import useOnClickOutside from 'use-onclickoutside'
import styled from 'styled-components'

const Wrapper = styled.div`
  // display: ${p => p.open ? 'flex' : 'none'};
  display: flex;
  position: absolute;
  top: 45px;
  left: 0px;
  // right: -2px;
  padding: 20px;
  width: 280px;
  // height: 50px;
  background-color: #fff;
  /* border: 3px solid #06c; */
  border-radius: 5px;
  /* box-shadow: 2px 2px 8px #aaa; */

  &:before {
    content: '';
    display: block;
    position: absolute;
    top: -8px;
    right: 20px;
    border-bottom: 8px solid #fff;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    
    z-index: 1;
  }

  &:after {
    content: '';
    display: block;
    position: absolute;
    top: -13px;
    right: 18px;
    border-bottom: 10px solid #06c;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
  }
`

const Input = styled.input`
  flex: 1;
  font-family: 'Helvetica Neue';
  font-size: 14px;
  color: #444;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 3px;

  &:focus {
    outline: none;
  }
`

Input.defaultProps = {
  placeholder: 'Enter the URL of the link'
}

const Button = styled.button`
  margin-left: 8px;
  padding: 10px;
  border: none;
  border-radius: 5px;
  background-color: #4267B2;
  font-weight: bold;
  color: #fff;
  cursor: pointer;
`

const LinkPrompt = ({ setOpen, submitLink }) => {
  const ref = useRef()
  useOnClickOutside(ref, () => setOpen(false))

  const onSubmit = () => {
    submitLink(ref.current.firstChild.value)
    setOpen(false)
  }

  return (
    <Wrapper ref={ref}>
      <Input autoFocus onKeyPress={e => e.which === 13 && onSubmit()} />
      <Button onClick={() => onSubmit()}>OK</Button>
    </Wrapper>
  )
}

export default LinkPrompt